import { jsonInstance } from "./Api";

class LatencyService {
  getLatencyInsights(params) {
    return jsonInstance.get("/latency/insights", { params });
  }
}

export default new LatencyService();
